import * as React from 'react'

import * as styles from './Header.module.less'

export interface HeaderProps {
    content?: React.ReactNode
}

export const Header: React.FC<HeaderProps> = props => {
    return <div className={styles.header}>{props.content}</div>
}
